<template>
  <el-dialog
    v-if="visible"
    visible
    show-close
    top="5vh"
    width="90%"
    :title="$l('dialog_title_chooseAmzStore') || '选择亚马逊店铺'"
    :modal="false"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
  >
    <Main ref="main" @checkbox-change="(data) => (checkedRows = data)" />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge
        class="ml-2"
        :value="checkedRowCount"
        :hidden="!checkedRowCount"
      >
        <el-button
          type="primary"
          size="small"
          @click="confirm()"
          :disabled="!checkedRowCount"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: { visible: { type: Boolean, default: false } },
  data() {
    return { checkedRows: [] }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.$refs.main.clearCheckboxRow()
    },
    confirm() {
      if (!this.checkedRowCount) return
      this.$emit('confirm', this.checkedRows)
      this.close()
    },
  },
}
</script>
